module.exports = __webpack_public_path__ + "static/media/SuisseIntl-Regular-WebS.afc6208c.eot";